module.exports = __webpack_public_path__ + "static/media/stylish.2d90f7c8.png";